import React, {FunctionComponent} from "react";
import {Dialog, DialogTitle, ButtonBase, Button} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from "react-i18next"
import {links} from "/src/domain/shared/links";

interface AuthorizeDialogData {
    isDialogOpen: boolean;
    closeDialog: () => void;
    authUrl?: string,
    title?: string,
}

const AuthorizeDialog: FunctionComponent<AuthorizeDialogData> = ({
                                                                     isDialogOpen,
                                                                     closeDialog,
                                                                     authUrl,
                                                                     title,
                                                                 }) => {
    const {t} = useTranslation()
    const classes = useStyles()
    return (
        <Dialog open={isDialogOpen} onClose={closeDialog}>
            <div className={classes.dialog}>
                <DialogTitle>{title ? title : t('logIn')}</DialogTitle>
                <div className={classes.loginContainer}>
                    <Button className={classes.loginBtn} variant={"contained"} color={"secondary"}
                            href={authUrl || `${links.origin}/login?back=${window.location.href}`}>{t('login')}</Button>
                </div>
            </div>
        </Dialog>
    )
}

const useStyles = makeStyles({
    dialog: {
        padding: '1rem 1.5rem 1.5rem'
    },
    dialogBtnImg: {
        margin: '-0.2rem'
    },
    loginContainer: {
        margin: "1rem 0",
        display: "flex",
        justifyContent: "center"
    },
    loginBtn: {
        minWidth: "25rem",
        height: "48px"
    }
})

export default AuthorizeDialog